<template>
  <div class="vx-row">
    <div class="vx-col w-full flex flex-col">
      <vs-card>
        <global-header></global-header>
        <global-wrapper-list
          :loading="$apollo.queries.listNotifikasi.loading"
          :loadingType="'TwoLine'"
          :loadingList="5"
          :empty="listNotifikasi.length <= 0"
          :error="error"
          :btnShowMore="btnShowMore"
        >
          <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10" :settings="settings" :key="$vs.rtl">
            <ul class="bordered-items">
              <li v-for="(item, index) in listNotifikasi" :key="index" 
                class="flex justify-between px-4 py-4 notification cursor-pointer" 
                @click="updateNotification(item.id, item.notifikasiable_uuid, item.halaman)"
              >
                <div class="flex items-start">
                  <feather-icon :icon="item.ikon" 
                    :svgClasses="item.is_read == 0 ? [`text-primary`, 'stroke-current mr-1 h-6 w-6'] 
                      : [`text-default`, 'stroke-current mr-1 h-6 w-6']">
                  </feather-icon>
                  <div class="mx-2">
                    <span class="font-medium block notification-title" 
                      :class="item.is_read == 0 ? [`text-primary`] : [`text-default`]">
                      {{ item.judul }}</span>
                    <small>{{ item.konten }}</small>
                  </div>
                </div>
                <small class="mt-1 whitespace-no-wrap">{{ item.created_at | indonesian_date_time }}</small>
              </li>
            </ul>
          </component>
        </global-wrapper-list>
      </vs-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import firebase from 'firebase/app';
import 'firebase/messaging'
import {GET_ALL as ALL_NOTIFIKASI} from '@/query/notifikasi';
import {UPDATE} from '@/query/notifikasi';
import vSelect from "vue-select";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components : {
    "v-select": vSelect,
    VuePerfectScrollbar,
  },
  data() {
    return {
      listNotifikasi : [],
      settings: {
        maxScrollbarLength: 100,
        wheelSpeed: .60
      },
      error: false,
      paginationPage: 1
    };
  },
  computed : {
    ...mapState({
      search: state => state.globalApp.search,
      filter: state => state.globalApp.filter.list,
      reloadNotification: state => state.globalApp.notification.reloadData
    }),
    btnShowMore() {
      return this.listNotifikasi.paginatorInfo
        ? this.listNotifikasi.paginatorInfo.hasMorePages
        : false;
    },
    filterForms(){
      return [
        {
          label: "Jenis Notifikasi",
          value: "NOTIFIKASIABLE_TYPE",
          component: "vs-select",
          options: [
            {value : "App\\Models\\Agenda", label : 'Notifikasi Agenda'},
            {value : "App\\Models\\Surat", label : 'Notifikasi Surat'},
          ]
        },
        {
          label: "Status Notifikasi",
          value: "IS_READ",
          component: "vs-select",
          options: [
            {value : 0, label : 'Belum Dibaca'},
            {value : 1, label : 'Sudah Dibaca'},
          ]
        }
      ]
    },
    defaultVars() {
      const newWhere = { ...this.searchVars, ...this.filterVars };
      return {
        perPage: 20,
        page: this.paginationPage,
        where: newWhere,
        orderBy: [{ field: "CREATED_AT", order: "DESC" }]
      };
    },
    searchVars() {
      const query = this.search.query;
      return {
        OR: [
          {
            column: "JUDUL",
            operator: "LIKE",
            value: `%${query}%`
          },
          {
            column: "KONTEN",
            operator: "LIKE",
            value: `%${query}%`
          }
        ]
      };
    },
    filterVars() {
      let filterModified = this.filter;
      const finalFilter = filterModified.map((item) => {
        return {
          column: item.type.value,
          value: item.query.value
        }
      }); 

      return {
        AND : [...finalFilter, {column : 'PENGGUNA_ID', value: this.$sanctum.getUser().id}]
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  mounted(){
    this.$store.dispatch("globalApp/setHeaderTitle", 'List Notifikasi');
    this.$store.dispatch("globalApp/setFilterForms", this.filterForms);
    this.listenNotification();
  },
  apollo : {
    listNotifikasi : {
      query : ALL_NOTIFIKASI,
      update : (data) => {
        return data.notifikasi.data;
      },
      variables(){
        return {
          ...this.defaultVars
        }
      },
      fetchPolicy: "cache-and-network",
    },
  },
  methods : {
    refetchListNotifikasiQuery: _.debounce(function() {
      this.refreshListNotifikasiQuery();
    }, 300),
    refreshListNotifikasiQuery() {
      this.$nextTick().then(() => {
        this.error = false;
        this.paginationPage = 1;
        this.$apollo.queries.listNotifikasi.setVariables({ ...this.defaultVars });
        this.$apollo.queries.listNotifikasi.refetch();
      });
    },
    async updateNotification(notificationId, notificationUuid, routeName){
      await this.$apollo
        .mutate({
          mutation: UPDATE,
          variables: {
            id : notificationId,
            input: {is_read : true}
          }
        })
        .then(() => {
          this.$store.dispatch("globalApp/reloadNotificationData", true);
          this.$router.push({name : routeName, params : {uuid : notificationUuid}});
        })
        .catch(error => {
          console.log(error);
          this.$vs.dialog({
            color: "danger",
            title: "Terjadi Kesalahan",
            text: "Error saat update notifikasi !"
          });
        });
    },
    listenNotification(){
      let messaging = firebase.messaging();
      messaging.onMessage(() => {
        this.$apollo.queries.listNotifikasi.refetch();
      });
    }
  },
  watch : {
    search: {
      handler() {
        this.refetchListNotifikasiQuery();
      },
      deep: true
    }
  }
};
</script>